import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-03df982f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-row text-start" }
const _hoisted_2 = { class: "fw-bold text-dark ps-3" }
const _hoisted_3 = { slot: "content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  id: "open-modal-product-change",
  expand: "block"
}, null, -1))

import { ref } from 'vue';
import { CartProduct } from '@/services/flyingBlue';
import { IonAccordion, IonItem } from '@ionic/vue';
import ProductModalChange from './ProductModalChange.vue';
import ProductAccordionItem from './ProductAccordionItem.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductAccordeon',
  props: {
    products: {},
    categoryTitle: {}
  },
  emits: ['productTap'],
  setup(__props: any) {





const currentProduct = ref<CartProduct>();
const isModalOpen = ref(false);

const openProductChangeModal = (product: CartProduct) => {
  currentProduct.value = product;
  isModalOpen.value = true;
};

const handleClosedModal = () => {
  isModalOpen.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonAccordion), {
    key: `${_ctx.categoryTitle}`,
    value: `${_ctx.categoryTitle}`,
    class: "bg-transparent p-2 mt-3"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonItem), {
        slot: "header",
        color: "tertiary",
        lines: "none",
        class: "rounded-pill"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.categoryTitle), 1)
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
          return (_openBlock(), _createBlock(ProductAccordionItem, {
            key: `product-${product.productId}`,
            "cart-product": product,
            onChange: ($event: any) => (openProductChangeModal(product)),
            onProductTap: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('productTap', $event)))
          }, null, 8, ["cart-product", "onChange"]))
        }), 128))
      ]),
      _hoisted_4,
      (currentProduct.value)
        ? (_openBlock(), _createBlock(ProductModalChange, {
            key: 0,
            "is-open": isModalOpen.value,
            "current-product": currentProduct.value,
            onCloseModal: _cache[1] || (_cache[1] = ($event: any) => (handleClosedModal())),
            onProductTap: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('productTap', $event)))
          }, null, 8, ["is-open", "current-product"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["value"]))
}
}

})